import { create } from 'zustand';

export interface MentionNavigatorContext {
  contextKey: string;
  mentionIds: string[];
  total: number;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  fetchNextPage: (() => void) | null;
}

interface MentionNavigatorState {
  contextKey: string | null;
  mentionIds: string[];
  total: number;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  fetchNextPage: (() => void) | null;
  setContext: (ctx: MentionNavigatorContext) => void;
  clear: (contextKey?: string) => void;
}

const EMPTY_STATE = {
  contextKey: null,
  mentionIds: [],
  total: 0,
  hasNextPage: false,
  isFetchingNextPage: false,
  fetchNextPage: null,
};

export const useMentionNavigatorStore = create<MentionNavigatorState>((set, get) => ({
  ...EMPTY_STATE,
  setContext: (ctx) =>
    set({
      contextKey: ctx.contextKey,
      mentionIds: ctx.mentionIds,
      total: ctx.total,
      hasNextPage: ctx.hasNextPage,
      isFetchingNextPage: ctx.isFetchingNextPage,
      fetchNextPage: ctx.fetchNextPage,
    }),
  clear: (contextKey) => {
    if (contextKey === undefined || get().contextKey === contextKey) {
      set({ ...EMPTY_STATE });
    }
  },
}));
